import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Drawer, Button, Tooltip, Select, Input } from 'antd';
import cloneDeep from 'lodash/cloneDeep';

import {
    getOptionsUserBillingDetails,
    saveUserBillingDetails
} from 'services/user';

const { TextArea } = Input;
const { Option } = Select;

const EditUserBillingDetails = (props) => {
    const [billingData, setBillingData] = useState([]);
    const [billingDataOptions, setBillingDataOptions] = useState([]);

    useEffect(() => {
        getOptionsUserBillingDetails().then((res) => {
            const newOptions = {};
            const data = res.data.actions.POST;
            newOptions['customer_type'] = data.customer_type.choices;
            newOptions['salutation'] = data.salutation.choices;
            newOptions['country'] = data.country.choices;
            // console.log(newOptions);
            setBillingDataOptions(newOptions);
        });
    }, []);

    useEffect(() => {
        setBillingData(cloneDeep(props.billingData));
    }, [props.billingData]);

    const handleInputChange = (target, value, option = false) => {
        let newBillingData = cloneDeep(billingData);
        if (option && option.hasOwnProperty('display_name')) {
            newBillingData[target + '_display'] = option.display_name;
        }
        newBillingData[target] = value;
        setBillingData(newBillingData);
    };

    const generateSelectOptions = (data) => {
        let options = [];

        for (let i in data) {
            options.push(
                <Option
                    key={data[i].value}
                    value={data[i].value}
                    display_name={data[i].display_name}
                >
                    {data[i].display_name}
                </Option>
            );
        }

        return options;
    };

    const mapCustomerType = generateSelectOptions(
        billingDataOptions.customer_type
    );

    const mapCountry = generateSelectOptions(billingDataOptions.country);

    const mapSalutation = generateSelectOptions(billingDataOptions.salutation);

    const onSearchCountry = (value) => {
        // console.log('search:', value);
    };

    const setNullIfEmptyString = (items) => {
        let newDetails = {};
        for (let item in items) {
            newDetails[item] = items[item] == '' ? null : items[item];
        }

        return newDetails;
    };

    const handleButtoSave = () => {
        // console.log(`billingData`, billingData);
        const newBillingData = setNullIfEmptyString(billingData);
        saveUserBillingDetails(newBillingData).catch((err) => {
            console.log(err);
        });
        props.setBillingData(billingData);
        setTimeout(() => {
            props.onClose();
        }, 1000);
    };

    const billingForm = (bd) => {
        return (
            <div key="name">
                <div className="edit-card">
                    <div className="name">Title</div>
                    <div className="value">
                        {/* <input
                            onChange={(e) =>
                                handleInputChange('salutation', e.target.value)
                            }
                            value={bd.salutation}
                        /> */}
                        <Select
                            value={bd.salutation}
                            style={{
                                width: '100%'
                            }}
                            onChange={(value, option) => {
                                handleInputChange('salutation', value, option);
                            }}
                        >
                            {mapSalutation}
                        </Select>
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">First Name</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('first_name', e.target.value)
                            }
                            value={bd.first_name}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">Last Name</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('last_name', e.target.value)
                            }
                            value={bd.last_name}
                        />
                    </div>
                </div>

                {/*  */}
                <div className="edit-card">
                    <div className="name">Customer Type</div>
                    <div className="value">
                        {/* <input
                            onChange={(e) =>
                                handleInputChange(
                                    'customer_type',
                                    e.target.value
                                )
                            }
                            value={bd.customer_type}
                        /> */}
                        <Select
                            value={bd.customer_type}
                            style={{
                                width: '100%'
                            }}
                            onChange={(value, option) => {
                                handleInputChange(
                                    'customer_type',
                                    value,
                                    option
                                );
                            }}
                        >
                            {mapCustomerType}
                        </Select>
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">Organization</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange(
                                    'organization',
                                    e.target.value
                                )
                            }
                            value={bd.organization}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">Tax ID Number</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('vat_tin_no', e.target.value)
                            }
                            value={bd.vat_tin_no}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">Country</div>
                    <div className="value">
                        {/* <input
                            onChange={(e) =>
                                handleInputChange('country', e.target.value)
                            }
                            value={bd.country}
                        /> */}
                        <Select
                            value={bd.country}
                            className="select-country"
                            style={{ width: '100%' }}
                            showSearch
                            placeholder="Select Country"
                            optionFilterProp="children"
                            onSearch={onSearchCountry}
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            onChange={(value, option) => {
                                handleInputChange('country', value, option);
                            }}
                        >
                            {mapCountry}
                        </Select>
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">Street</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('street', e.target.value)
                            }
                            value={bd.street}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">City</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('city', e.target.value)
                            }
                            value={bd.city}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">State</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('state', e.target.value)
                            }
                            value={bd.state}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">ZIP Code</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('zip_code', e.target.value)
                            }
                            value={bd.zip_code}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">Phone</div>
                    <div className="value">
                        <input
                            onChange={(e) =>
                                handleInputChange('phone', e.target.value)
                            }
                            value={bd.phone}
                        />
                    </div>
                </div>

                <div className="edit-card">
                    <div className="name">Notes</div>
                    <div className="value">
                        <TextArea
                            showCount
                            // maxLength={100}
                            style={{
                                height: 120,
                                border: '1px solid #E5E5E5'
                            }}
                            onChange={(e) =>
                                handleInputChange(
                                    'additional_information',
                                    e.target.value
                                )
                            }
                            value={bd.additional_information}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Drawer
                // title="Basic Drawer"
                placement="right"
                onClose={props.onClose}
                visible={props.visible}
                closable={false}
                width={357}
            >
                <div className="edit-details-billing-container">
                    <div className="header">
                        <div className="title">Edit Details</div>
                    </div>
                    <div className="body">
                        {billingForm(billingData)}
                        <div className="button-container">
                            <div className="btn-save">
                                {JSON.stringify(billingData) ==
                                JSON.stringify(props.billingData) ? (
                                    <Tooltip title="There's nothing to change">
                                        <Button disabled>Save</Button>
                                    </Tooltip>
                                ) : (
                                    <Button onClick={handleButtoSave}>
                                        Save
                                    </Button>
                                )}
                            </div>
                            <div className="btn-cancel">
                                <Button onClick={props.onClose}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    );
};

export default EditUserBillingDetails;
